<template>
  <div class="flex gap-5 mb-5 flex-col md:flex-row">
<!--    tailwind 3 equal width columns -->
    <div
      v-for="item in summary" :key="item.id"
      class="md:w-1/3 shadow-md bg-white px-3.5 py-9 rounded-md text-center flex-grow-0 hover:shadow-lg"
    >
      <div class="text-xl font-bold mb-2.5">{{ item.title }}</div>
      <div class="text-2xl font-bold mb-3">{{ item.subtitle }}</div>
      <div class="text-gray-400">{{ item.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    summary: {
      type: Array,
      default: () => [
        {
          id: 1,
          title: 'Account',
          subtitle: 'DKK 1356,00',
          desc: 'Amount that has not been transferred to your bank account yet.'
        },
        {
          id: 2,
          title: 'Account',
          subtitle: '17',
          desc: 'Total amount of online payments you have received via EasyPay.'
        },
        {
          id: 3,
          title: 'Future Payments',
          subtitle: 'DKK 476,83',
          desc: 'Amount that will be charged in the future via EasyPay.'
        }
      ]
    }
  }
}
</script>
